export interface PhoneNumberCountryCode {
  text: string;
  code: number;
  country: string;
  shortDisplay: string;
}

export const COUNTRY_CONFIGS: PhoneNumberCountryCode[] = [
  {
    text: '🇺🇸 +1 United States',
    shortDisplay: '🇺🇸 +1',
    code: 1,
    country: 'US',
  },
  { text: '🇨🇦 +1 Canada', shortDisplay: '🇨🇦 +1', code: 1, country: 'CA' },
  { text: '🇷🇺 +7 Russia', shortDisplay: '🇷🇺 +7', code: 7, country: 'RU' },
  { text: '🇪🇬 +20 Egypt', shortDisplay: '🇪🇬 +20', code: 20, country: 'EG' },
  {
    text: '🇿🇦 +27 South Africa',
    shortDisplay: '🇿🇦 +27',
    code: 27,
    country: 'ZA',
  },
  { text: '🇬🇷 +30 Greece', shortDisplay: '🇬🇷 +30', code: 30, country: 'GR' },
  {
    text: '🇳🇱 +31 Netherlands',
    shortDisplay: '🇳🇱 +31',
    code: 31,
    country: 'NL',
  },
  {
    text: '🇧🇪 +32 Belgium',
    shortDisplay: '🇧🇪 +32',
    code: 32,
    country: 'BE',
  },
  { text: '🇫🇷 +33 France', shortDisplay: '🇫🇷 +33', code: 33, country: 'FR' },
  { text: '🇪🇸 +34 Spain', shortDisplay: '🇪🇸 +34', code: 34, country: 'ES' },
  {
    text: '🇭🇺 +36 Hungary',
    shortDisplay: '🇭🇺 +36',
    code: 36,
    country: 'HU',
  },
  { text: '🇮🇹 +39 Italy', shortDisplay: '🇮🇹 +39', code: 39, country: 'IT' },
  {
    text: '🇷🇴 +40 Romania',
    shortDisplay: '🇷🇴 +40',
    code: 40,
    country: 'RO',
  },
  {
    text: '🇨🇭 +41 Switzerland',
    shortDisplay: '🇨🇭 +41',
    code: 41,
    country: 'CH',
  },
  {
    text: '🇦🇹 +43 Austria',
    shortDisplay: '🇦🇹 +43',
    code: 43,
    country: 'AT',
  },
  {
    text: '🇬🇧 +44 United Kingdom',
    shortDisplay: '🇬🇧 +44',
    code: 44,
    country: 'GB',
  },
  {
    text: '🇩🇰 +45 Denmark',
    shortDisplay: '🇩🇰 +45',
    code: 45,
    country: 'DK',
  },
  { text: '🇸🇪 +46 Sweden', shortDisplay: '🇸🇪 +46', code: 46, country: 'SE' },
  { text: '🇳🇴 +47 Norway', shortDisplay: '🇳🇴 +47', code: 47, country: 'NO' },
  { text: '🇵🇱 +48 Poland', shortDisplay: '🇵🇱 +48', code: 48, country: 'PL' },
  {
    text: '🇩🇪 +49 Germany',
    shortDisplay: '🇩🇪 +49',
    code: 49,
    country: 'DE',
  },
  { text: '🇵🇪 +51 Peru', shortDisplay: '🇵🇪 +51', code: 51, country: 'PE' },
  { text: '🇲🇽 +52 Mexico', shortDisplay: '🇲🇽 +52', code: 52, country: 'MX' },
  { text: '🇨🇺 +53 Cuba', shortDisplay: '🇨🇺 +53', code: 53, country: 'CU' },
  {
    text: '🇦🇷 +54 Argentina',
    shortDisplay: '🇦🇷 +54',
    code: 54,
    country: 'AR',
  },
  { text: '🇧🇷 +55 Brazil', shortDisplay: '🇧🇷 +55', code: 55, country: 'BR' },
  { text: '🇨🇱 +56 Chile', shortDisplay: '🇨🇱 +56', code: 56, country: 'CL' },
  {
    text: '🇨🇴 +57 Colombia',
    shortDisplay: '🇨🇴 +57',
    code: 57,
    country: 'CO',
  },
  {
    text: '🇻🇪 +58 Venezuela',
    shortDisplay: '🇻🇪 +58',
    code: 58,
    country: 'VE',
  },
  {
    text: '🇲🇾 +60 Malaysia',
    shortDisplay: '🇲🇾 +60',
    code: 60,
    country: 'MY',
  },
  {
    text: '🇦🇺 +61 Australia',
    shortDisplay: '🇦🇺 +61',
    code: 61,
    country: 'AU',
  },
  {
    text: '🇮🇩 +62 Indonesia',
    shortDisplay: '🇮🇩 +62',
    code: 62,
    country: 'ID',
  },
  {
    text: '🇵🇭 +63 Philippines',
    shortDisplay: '🇵🇭 +63',
    code: 63,
    country: 'PH',
  },
  {
    text: '🇳🇿 +64 New Zealand',
    shortDisplay: '🇳🇿 +64',
    code: 64,
    country: 'NZ',
  },
  {
    text: '🇸🇬 +65 Singapore',
    shortDisplay: '🇸🇬 +65',
    code: 65,
    country: 'SG',
  },
  {
    text: '🇹🇭 +66 Thailand',
    shortDisplay: '🇹🇭 +66',
    code: 66,
    country: 'TH',
  },
  { text: '🇯🇵 +81 Japan', shortDisplay: '🇯🇵 +81', code: 81, country: 'JP' },
  {
    text: '🇰🇷 +82 South Korea',
    shortDisplay: '🇰🇷 +82',
    code: 82,
    country: 'KR',
  },
  {
    text: '🇻🇳 +84 Vietnam',
    shortDisplay: '🇻🇳 +84',
    code: 84,
    country: 'VN',
  },
  { text: '🇨🇳 +86 China', shortDisplay: '🇨🇳 +86', code: 86, country: 'CN' },
  { text: '🇹🇷 +90 Turkey', shortDisplay: '🇹🇷 +90', code: 90, country: 'TR' },
  { text: '🇮🇳 +91 India', shortDisplay: '🇮🇳 +91', code: 91, country: 'IN' },
  {
    text: '🇵🇰 +92 Pakistan',
    shortDisplay: '🇵🇰 +92',
    code: 92,
    country: 'PK',
  },
  {
    text: '🇦🇫 +93 Afghanistan',
    shortDisplay: '🇦🇫 +93',
    code: 93,
    country: 'AF',
  },
  {
    text: '🇱🇰 +94 Sri Lanka',
    shortDisplay: '🇱🇰 +94',
    code: 94,
    country: 'LK',
  },
  {
    text: '🇲🇲 +95 Myanmar',
    shortDisplay: '🇲🇲 +95',
    code: 95,
    country: 'MM',
  },
  { text: '🇮🇷 +98 Iran', shortDisplay: '🇮🇷 +98', code: 98, country: 'IR' },
  {
    text: '🇲🇦 +212 Morocco',
    shortDisplay: '🇲🇦 +212',
    code: 212,
    country: 'MA',
  },
  {
    text: '🇩🇿 +213 Algeria',
    shortDisplay: '🇩🇿 +213',
    code: 213,
    country: 'DZ',
  },
  {
    text: '🇹🇳 +216 Tunisia',
    shortDisplay: '🇹🇳 +216',
    code: 216,
    country: 'TN',
  },
  {
    text: '🇱🇾 +218 Libya',
    shortDisplay: '🇱🇾 +218',
    code: 218,
    country: 'LY',
  },
  {
    text: '🇬🇲 +220 Gambia',
    shortDisplay: '🇬🇲 +220',
    code: 220,
    country: 'GM',
  },
  {
    text: '🇸🇳 +221 Senegal',
    shortDisplay: '🇸🇳 +221',
    code: 221,
    country: 'SN',
  },
  {
    text: '🇲🇷 +222 Mauritania',
    shortDisplay: '🇲🇷 +222',
    code: 222,
    country: 'MR',
  },
  {
    text: '🇲🇱 +223 Mali',
    shortDisplay: '🇲🇱 +223',
    code: 223,
    country: 'ML',
  },
  {
    text: '🇬🇳 +224 Guinea',
    shortDisplay: '🇬🇳 +224',
    code: 224,
    country: 'GN',
  },
  {
    text: '🇨🇮 +225 Ivory Coast',
    shortDisplay: '🇨🇮 +225',
    code: 225,
    country: 'CI',
  },
  {
    text: '🇧🇫 +226 Burkina Faso',
    shortDisplay: '🇧🇫 +226',
    code: 226,
    country: 'BF',
  },
  {
    text: '🇳🇪 +227 Niger',
    shortDisplay: '🇳🇪 +227',
    code: 227,
    country: 'NE',
  },
  {
    text: '🇹🇬 +228 Togo',
    shortDisplay: '🇹🇬 +228',
    code: 228,
    country: 'TG',
  },
  {
    text: '🇧🇯 +229 Benin',
    shortDisplay: '🇧🇯 +229',
    code: 229,
    country: 'BJ',
  },
  {
    text: '🇲🇺 +230 Mauritius',
    shortDisplay: '🇲🇺 +230',
    code: 230,
    country: 'MU',
  },
  {
    text: '🇱🇷 +231 Liberia',
    shortDisplay: '🇱🇷 +231',
    code: 231,
    country: 'LR',
  },
  {
    text: '🇸🇱 +232 Sierra Leone',
    shortDisplay: '🇸🇱 +232',
    code: 232,
    country: 'SL',
  },
  {
    text: '🇬🇭 +233 Ghana',
    shortDisplay: '🇬🇭 +233',
    code: 233,
    country: 'GH',
  },
  {
    text: '🇳🇬 +234 Nigeria',
    shortDisplay: '🇳🇬 +234',
    code: 234,
    country: 'NG',
  },
  {
    text: '🇹🇩 +235 Chad',
    shortDisplay: '🇹🇩 +235',
    code: 235,
    country: 'TD',
  },
  {
    text: '🇨🇫 +236 Central African Republic',
    shortDisplay: '🇨🇫 +236',
    code: 236,
    country: 'CF',
  },
  {
    text: '🇨🇲 +237 Cameroon',
    shortDisplay: '🇨🇲 +237',
    code: 237,
    country: 'CM',
  },
  {
    text: '🇨🇻 +238 Cape Verde',
    shortDisplay: '🇨🇻 +238',
    code: 238,
    country: 'CV',
  },
  {
    text: '🇸🇹 +239 Sao Tome and Principe',
    shortDisplay: '🇸🇹 +239',
    code: 239,
    country: 'ST',
  },
  {
    text: '🇬🇶 +240 Equatorial Guinea',
    shortDisplay: '🇬🇶 +240',
    code: 240,
    country: 'GQ',
  },
  {
    text: '🇬🇦 +241 Gabon',
    shortDisplay: '🇬🇦 +241',
    code: 241,
    country: 'GA',
  },
  {
    text: '🇨🇬 +242 Republic of the Congo',
    shortDisplay: '🇨🇬 +242',
    code: 242,
    country: 'CG',
  },
  {
    text: '🇨🇩 +243 Democratic Republic of the Congo',
    shortDisplay: '🇨🇩 +243',
    code: 243,
    country: 'CD',
  },
  {
    text: '🇦🇴 +244 Angola',
    shortDisplay: '🇦🇴 +244',
    code: 244,
    country: 'AO',
  },
  {
    text: '🇬🇼 +245 Guinea-Bissau',
    shortDisplay: '🇨🇬 +245',
    code: 245,
    country: 'GW',
  },
  {
    text: '🇮🇴 +246 British Indian Ocean Territory',
    shortDisplay: '🇮🇴 +246',
    code: 246,
    country: 'IO',
  },
  {
    text: '🇸🇨 +248 Seychelles',
    shortDisplay: '🇸🇨 +248',
    code: 248,
    country: 'SC',
  },
  {
    text: '🇸🇩 +249 Sudan',
    shortDisplay: '🇸🇩 +249',
    code: 249,
    country: 'SD',
  },
  {
    text: '🇷🇼 +250 Rwanda',
    shortDisplay: '🇷🇼 +250',
    code: 250,
    country: 'RW',
  },
  {
    text: '🇪🇹 +251 Ethiopia',
    shortDisplay: '🇪🇹 +251',
    code: 251,
    country: 'ET',
  },
  {
    text: '🇸🇴 +252 Somalia',
    shortDisplay: '🇸🇴 +252',
    code: 252,
    country: 'SO',
  },
  {
    text: '🇩🇯 +253 Djibouti',
    shortDisplay: '🇩🇯 +253',
    code: 253,
    country: 'DJ',
  },
  {
    text: '🇰🇪 +254 Kenya',
    shortDisplay: '🇰🇪 +254',
    code: 254,
    country: 'KE',
  },
  {
    text: '🇹🇿 +255 Tanzania',
    shortDisplay: '🇹🇿 +255',
    code: 255,
    country: 'TZ',
  },
  {
    text: '🇺🇬 +256 Uganda',
    shortDisplay: '🇺🇬 +256',
    code: 256,
    country: 'UG',
  },
  {
    text: '🇧🇮 +257 Burundi',
    shortDisplay: '🇧🇮 +257',
    code: 257,
    country: 'BI',
  },
  {
    text: '🇲🇿 +258 Mozambique',
    shortDisplay: '🇲🇿 +258',
    code: 258,
    country: 'MZ',
  },
  {
    text: '🇿🇲 +260 Zambia',
    shortDisplay: '🇿🇲 +260',
    code: 260,
    country: 'ZM',
  },
  {
    text: '🇲🇬 +261 Madagascar',
    shortDisplay: '🇲🇬 +261',
    code: 261,
    country: 'MG',
  },
  {
    text: '🇷🇪 +262 Reunion',
    shortDisplay: '🇷🇪 +262',
    code: 262,
    country: 'RE',
  },
  {
    text: '🇿🇼 +263 Zimbabwe',
    shortDisplay: '🇿🇼 +263',
    code: 263,
    country: 'ZW',
  },
  {
    text: '🇳🇦 +264 Namibia',
    shortDisplay: '🇳🇦 +264',
    code: 264,
    country: 'NA',
  },
  {
    text: '🇲🇼 +265 Malawi',
    shortDisplay: '🇲🇼 +265',
    code: 265,
    country: 'MW',
  },
  {
    text: '🇱🇸 +266 Lesotho',
    shortDisplay: '🇱🇸 +266',
    code: 266,
    country: 'LS',
  },
  {
    text: '🇧🇼 +267 Botswana',
    shortDisplay: '🇧🇼 +267',
    code: 267,
    country: 'BW',
  },
  {
    text: '🇸🇿 +268 Eswatini',
    shortDisplay: '🇸🇿 +268',
    code: 268,
    country: 'SZ',
  },
  {
    text: '🇰🇲 +269 Comoros',
    shortDisplay: '🇰🇲 +269',
    code: 269,
    country: 'KM',
  },
  {
    text: '🇸🇭 +290 Saint Helena',
    shortDisplay: '🇸🇭 +290',
    code: 290,
    country: 'SH',
  },
  {
    text: '🇪🇷 +291 Eritrea',
    shortDisplay: '🇪🇷 +291',
    code: 291,
    country: 'ER',
  },
  {
    text: '🇦🇼 +297 Aruba',
    shortDisplay: '🇦🇼 +297',
    code: 297,
    country: 'AW',
  },
  {
    text: '🇫🇴 +298 Faroe Islands',
    shortDisplay: '🇫🇴 +298',
    code: 298,
    country: 'FO',
  },
  {
    text: '🇬🇱 +299 Greenland',
    shortDisplay: '🇬🇱 +299',
    code: 299,
    country: 'GL',
  },
  {
    text: '🇬🇮 +350 Gibraltar',
    shortDisplay: '🇬🇮 +350',
    code: 350,
    country: 'GI',
  },
  {
    text: '🇵🇹 +351 Portugal',
    shortDisplay: '🇵🇹 +351',
    code: 351,
    country: 'PT',
  },
  {
    text: '🇱🇺 +352 Luxembourg',
    shortDisplay: '🇱🇺 +352',
    code: 352,
    country: 'LU',
  },
  {
    text: '🇮🇪 +353 Ireland',
    shortDisplay: '🇮🇪 +353',
    code: 353,
    country: 'IE',
  },
  {
    text: '🇮🇸 +354 Iceland',
    shortDisplay: '🇮🇸 +354',
    code: 354,
    country: 'IS',
  },
  {
    text: '🇦🇱 +355 Albania',
    shortDisplay: '🇦🇱 +355',
    code: 355,
    country: 'AL',
  },
  {
    text: '🇲🇹 +356 Malta',
    shortDisplay: '🇲🇹 +356',
    code: 356,
    country: 'MT',
  },
  {
    text: '🇨🇾 +357 Cyprus',
    shortDisplay: '🇨🇾 +357',
    code: 357,
    country: 'CY',
  },
  {
    text: '🇫🇮 +358 Finland',
    shortDisplay: '🇫🇮 +358',
    code: 358,
    country: 'FI',
  },
  {
    text: '🇧🇬 +359 Bulgaria',
    shortDisplay: '🇧🇬 +359',
    code: 359,
    country: 'BG',
  },
  {
    text: '🇱🇹 +370 Lithuania',
    shortDisplay: '🇱🇹 +370',
    code: 370,
    country: 'LT',
  },
  {
    text: '🇱🇻 +371 Latvia',
    shortDisplay: '🇱🇻 +371',
    code: 371,
    country: 'LV',
  },
  {
    text: '🇪🇪 +372 Estonia',
    shortDisplay: '🇪🇪 +372',
    code: 372,
    country: 'EE',
  },
  {
    text: '🇲🇩 +373 Moldova',
    shortDisplay: '🇲🇩 +373',
    code: 373,
    country: 'MD',
  },
  {
    text: '🇦🇲 +374 Armenia',
    shortDisplay: '🇦🇲 +374',
    code: 374,
    country: 'AM',
  },
  {
    text: '🇧🇾 +375 Belarus',
    shortDisplay: '🇧🇾 +375',
    code: 375,
    country: 'BY',
  },
  {
    text: '🇦🇩 +376 Andorra',
    shortDisplay: '🇦🇩 +376',
    code: 376,
    country: 'AD',
  },
  {
    text: '🇲🇨 +377 Monaco',
    shortDisplay: '🇲🇨 +377',
    code: 377,
    country: 'MC',
  },
  {
    text: '🇸🇲 +378 San Marino',
    shortDisplay: '🇸🇲 +378',
    code: 378,
    country: 'SM',
  },
  {
    text: '🇺🇦 +380 Ukraine',
    shortDisplay: '🇺🇦 +380',
    code: 380,
    country: 'UA',
  },
  {
    text: '🇷🇸 +381 Serbia',
    shortDisplay: '🇷🇸 +381',
    code: 381,
    country: 'RS',
  },
  {
    text: '🇲🇪 +382 Montenegro',
    shortDisplay: '🇲🇪 +382',
    code: 382,
    country: 'ME',
  },
  {
    text: '🇭🇷 +385 Croatia',
    shortDisplay: '🇭🇷 +385',
    code: 385,
    country: 'HR',
  },
  {
    text: '🇸🇮 +386 Slovenia',
    shortDisplay: '🇸🇮 +386',
    code: 386,
    country: 'SI',
  },
  {
    text: '🇧🇦 +387 Bosnia and Herzegovina',
    shortDisplay: '🇧🇦 +387',
    code: 387,
    country: 'BA',
  },
  {
    text: '🇲🇰 +389 North Macedonia',
    shortDisplay: '🇲🇰 +389',
    code: 389,
    country: 'MK',
  },
  {
    text: '🇨🇿 +420 Czech Republic',
    shortDisplay: '🇨🇿 +420',
    code: 420,
    country: 'CZ',
  },
  {
    text: '🇸🇰 +421 Slovakia',
    shortDisplay: '🇸🇰 +421',
    code: 421,
    country: 'SK',
  },
  {
    text: '🇱🇮 +423 Liechtenstein',
    shortDisplay: '🇱🇮 +423',
    code: 423,
    country: 'LI',
  },
  {
    text: '🇫🇰 +500 Falkland Islands',
    shortDisplay: '🇫🇰 +500',
    code: 500,
    country: 'FK',
  },
  {
    text: '🇧🇿 +501 Belize',
    shortDisplay: '🇧🇿 +501',
    code: 501,
    country: 'BZ',
  },
  {
    text: '🇬🇹 +502 Guatemala',
    shortDisplay: '🇬🇹 +502',
    code: 502,
    country: 'GT',
  },
  {
    text: '🇸🇻 +503 El Salvador',
    shortDisplay: '🇸🇻 +503',
    code: 503,
    country: 'SV',
  },
  {
    text: '🇭🇳 +504 Honduras',
    shortDisplay: '🇭🇳 +504',
    code: 504,
    country: 'HN',
  },
  {
    text: '🇳🇮 +505 Nicaragua',
    shortDisplay: '🇳🇮 +505',
    code: 505,
    country: 'NI',
  },
  {
    text: '🇨🇷 +506 Costa Rica',
    shortDisplay: '🇨🇷 +506',
    code: 506,
    country: 'CR',
  },
  {
    text: '🇵🇦 +507 Panama',
    shortDisplay: '🇵🇦 +507',
    code: 507,
    country: 'PA',
  },
  {
    text: '🇵🇲 +508 Saint Pierre and Miquelon',
    shortDisplay: '🇵🇲 +508',
    code: 508,
    country: 'PM',
  },
  {
    text: '🇭🇹 +509 Haiti',
    shortDisplay: '🇭🇹 +509',
    code: 509,
    country: 'HT',
  },
  {
    text: '🇬🇵 +590 Guadeloupe',
    shortDisplay: '🇬🇵 +590',
    code: 590,
    country: 'GP',
  },
  {
    text: '🇧🇴 +591 Bolivia',
    shortDisplay: '🇧🇴 +591',
    code: 591,
    country: 'BO',
  },
  {
    text: '🇬🇾 +592 Guyana',
    shortDisplay: '🇬🇾 +592',
    code: 592,
    country: 'GY',
  },
  {
    text: '🇪🇨 +593 Ecuador',
    shortDisplay: '🇪🇨 +593',
    code: 593,
    country: 'EC',
  },
  {
    text: '🇬🇫 +594 French Guiana',
    shortDisplay: '🇬🇫 +594',
    code: 594,
    country: 'GF',
  },
  {
    text: '🇵🇾 +595 Paraguay',
    shortDisplay: '🇵🇾 +595',
    code: 595,
    country: 'PY',
  },
  {
    text: '🇲🇶 +596 Martinique',
    shortDisplay: '🇲🇶 +596',
    code: 596,
    country: 'MQ',
  },
  {
    text: '🇸🇷 +597 Suriname',
    shortDisplay: '🇸🇷 +597',
    code: 597,
    country: 'SR',
  },
  {
    text: '🇺🇾 +598 Uruguay',
    shortDisplay: '🇺🇾 +598',
    code: 598,
    country: 'UY',
  },
  {
    text: '🇨🇼 +599 Curaçao',
    shortDisplay: '🇨🇼 +599',
    code: 599,
    country: 'CW',
  },
  {
    text: '🇹🇱 +670 Timor-Leste',
    shortDisplay: '🇹🇱 +670',
    code: 670,
    country: 'TL',
  },
  {
    text: '🇦🇶 +672 Antarctica',
    shortDisplay: '🇦🇶 +672',
    code: 672,
    country: 'AQ',
  },
  {
    text: '🇧🇳 +673 Brunei',
    shortDisplay: '🇧🇳 +673',
    code: 673,
    country: 'BN',
  },
  {
    text: '🇳🇷 +674 Nauru',
    shortDisplay: '🇳🇷 +674',
    code: 674,
    country: 'NR',
  },
  {
    text: '🇵🇬 +675 Papua New Guinea',
    shortDisplay: '🇵🇬 +675',
    code: 675,
    country: 'PG',
  },
  {
    text: '🇹🇴 +676 Tonga',
    shortDisplay: '🇹🇴 +676',
    code: 676,
    country: 'TO',
  },
  {
    text: '🇸🇧 +677 Solomon Islands',
    shortDisplay: '🇸🇧 +677',
    code: 677,
    country: 'SB',
  },
  {
    text: '🇻🇺 +678 Vanuatu',
    shortDisplay: '🇻🇺 +678',
    code: 678,
    country: 'VU',
  },
  {
    text: '🇫🇯 +679 Fiji',
    shortDisplay: '🇫🇯 +679',
    code: 679,
    country: 'FJ',
  },
  {
    text: '🇵🇼 +680 Palau',
    shortDisplay: '🇵🇼 +680',
    code: 680,
    country: 'PW',
  },
  {
    text: '🇼🇫 +681 Wallis and Futuna',
    shortDisplay: '🇼🇫 +681',
    code: 681,
    country: 'WF',
  },
  {
    text: '🇨🇰 +682 Cook Islands',
    shortDisplay: '🇨🇰 +682',
    code: 682,
    country: 'CK',
  },
  {
    text: '🇳🇺 +683 Niue',
    shortDisplay: '🇳🇺 +683',
    code: 683,
    country: 'NU',
  },
  {
    text: '🇼🇸 +685 Samoa',
    shortDisplay: '🇼🇸 +685',
    code: 685,
    country: 'WS',
  },
  {
    text: '🇰🇮 +686 Kiribati',
    shortDisplay: '🇰🇮 +686',
    code: 686,
    country: 'KI',
  },
  {
    text: '🇳🇨 +687 New Caledonia',
    shortDisplay: '🇳🇨 +687',
    code: 687,
    country: 'NC',
  },
  {
    text: '🇹🇻 +688 Tuvalu',
    shortDisplay: '🇹🇻 +688',
    code: 688,
    country: 'TV',
  },
  {
    text: '🇵🇫 +689 French Polynesia',
    shortDisplay: '🇵🇫 +689',
    code: 689,
    country: 'PF',
  },
  {
    text: '🇹🇰 +690 Tokelau',
    shortDisplay: '🇹🇰 +690',
    code: 690,
    country: 'TK',
  },
  {
    text: '🇫🇲 +691 Federated States of Micronesia',
    shortDisplay: '🇫🇲 +691',
    code: 691,
    country: 'FM',
  },
  {
    text: '🇲🇭 +692 Marshall Islands',
    shortDisplay: '🇲🇭 +692',
    code: 692,
    country: 'MH',
  },
  {
    text: '🇰🇵 +850 North Korea',
    shortDisplay: '🇰🇵 +850',
    code: 850,
    country: 'KP',
  },
  {
    text: '🇭🇰 +852 Hong Kong',
    shortDisplay: '🇭🇰 +852',
    code: 852,
    country: 'HK',
  },
  {
    text: '🇲🇴 +853 Macau',
    shortDisplay: '🇲🇴 +853',
    code: 853,
    country: 'MO',
  },
  {
    text: '🇰🇭 +855 Cambodia',
    shortDisplay: '🇰🇭 +855',
    code: 855,
    country: 'KH',
  },
  {
    text: '🇱🇦 +856 Laos',
    shortDisplay: '🇱🇦 +856',
    code: 856,
    country: 'LA',
  },
  {
    text: '🇧🇩 +880 Bangladesh',
    shortDisplay: '🇧🇩 +880',
    code: 880,
    country: 'BD',
  },
  {
    text: '🇹🇼 +886 Taiwan',
    shortDisplay: '🇹🇼 +886',
    code: 886,
    country: 'TW',
  },
  {
    text: '🇲🇻 +960 Maldives',
    shortDisplay: '🇲🇻 +960',
    code: 960,
    country: 'MV',
  },
  {
    text: '🇱🇧 +961 Lebanon',
    shortDisplay: '🇱🇧 +961',
    code: 961,
    country: 'LB',
  },
  {
    text: '🇯🇴 +962 Jordan',
    shortDisplay: '🇯🇴 +962',
    code: 962,
    country: 'JO',
  },
  {
    text: '🇸🇾 +963 Syria',
    shortDisplay: '🇸🇾 +963',
    code: 963,
    country: 'SY',
  },
  {
    text: '🇮🇶 +964 Iraq',
    shortDisplay: '🇮🇶 +964',
    code: 964,
    country: 'IQ',
  },
  {
    text: '🇰🇼 +965 Kuwait',
    shortDisplay: '🇰🇼 +965',
    code: 965,
    country: 'KW',
  },
  {
    text: '🇸🇦 +966 Saudi Arabia',
    shortDisplay: '🇸🇦 +966',
    code: 966,
    country: 'SA',
  },
  {
    text: '🇾🇪 +967 Yemen',
    shortDisplay: '🇾🇪 +967',
    code: 967,
    country: 'YE',
  },
  {
    text: '🇴🇲 +968 Oman',
    shortDisplay: '🇴🇲 +968',
    code: 968,
    country: 'OM',
  },
  {
    text: '🇵🇸 +970 Palestine',
    shortDisplay: '🇵🇸 +970',
    code: 970,
    country: 'PS',
  },
  {
    text: '🇦🇪 +971 United Arab Emirates',
    shortDisplay: '🇦🇪 +971',
    code: 971,
    country: 'AE',
  },
  {
    text: '🇮🇱 +972 Israel',
    shortDisplay: '🇮🇱 +972',
    code: 972,
    country: 'IL',
  },
  {
    text: '🇧🇭 +973 Bahrain',
    shortDisplay: '🇧🇭 +973',
    code: 973,
    country: 'BH',
  },
  {
    text: '🇶🇦 +974 Qatar',
    shortDisplay: '🇶🇦 +974',
    code: 974,
    country: 'QA',
  },
  {
    text: '🇧🇹 +975 Bhutan',
    shortDisplay: '🇧🇹 +975',
    code: 975,
    country: 'BT',
  },
  {
    text: '🇲🇳 +976 Mongolia',
    shortDisplay: '🇲🇳 +976',
    code: 976,
    country: 'MN',
  },
  {
    text: '🇳🇵 +977 Nepal',
    shortDisplay: '🇳🇵 +977',
    code: 977,
    country: 'NP',
  },
  {
    text: '🇹🇯 +992 Tajikistan',
    shortDisplay: '🇹🇯 +992',
    code: 992,
    country: 'TJ',
  },
  {
    text: '🇹🇲 +993 Turkmenistan',
    shortDisplay: '🇹🇲 +993',
    code: 993,
    country: 'TM',
  },
  {
    text: '🇦🇿 +994 Azerbaijan',
    shortDisplay: '🇦🇿 +994',
    code: 994,
    country: 'AZ',
  },
  {
    text: '🇬🇪 +995 Georgia',
    shortDisplay: '🇬🇪 +995',
    code: 995,
    country: 'GE',
  },
  {
    text: '🇰🇬 +996 Kyrgyzstan',
    shortDisplay: '🇰🇬 +996',
    code: 996,
    country: 'KG',
  },
  {
    text: '🇺🇿 +998 Uzbekistan',
    shortDisplay: '🇺🇿 +998',
    code: 998,
    country: 'UZ',
  },
];

export const COUNTRY_CONFIG_BY_SHORT_DISPLAY = new Map(
  COUNTRY_CONFIGS.map((c) => [c.shortDisplay, c]),
);

export const COUNTRY_CONFIG_BY_COUNTRY = new Map(
  [...COUNTRY_CONFIGS].reverse().map((c) => [c.country, c]),
);
